export function loginSucesso(nomeUsuario) {
    return { type: 'LOGIN_SUCCESS', nomeUsuario };
}

export function logoutSucesso() {
    return { type: 'LOGOUT_SUCCESS' };
}


// WEBPACK FOOTER //
// ./src/redux/actions/autenticacaoAction.js